<template>
  <div class="page d-flex flex-column align-items-center justify-content-start">
    <div class="header-section text-center py-5 mb-4">
      <h1 class="display-4 font-weight-bold">{{ greeting() }}</h1>
      <p class="lead" v-if="curUser">{{ curUser }}</p>
    </div>
    <div class="float-form-container card-base p-4 rounded shadow-lg">
      <FloatAssignForm/>
    </div>
  </div>
</template>

<script>
import FloatAssignForm from "@/components/point-of-sale/float/FloatAssignForm";
import { authentication as auth } from '@/services/auth';

export default {
  name: "FloatView",
  async beforeMount() {
    try {
      const isCashierLoggedIn = await auth.isCashierLoggedIn();
      if (!isCashierLoggedIn) return this.$router.push({ name: 'setup' });
    } catch (e) {
      // Fallback: if auth service not ready, route to setup/login
      return this.$router.push({ name: 'setup' });
    }

    // If offline, skip float for now and go to POS
    if (!navigator.onLine) {
      try {
        const user = this.$store && this.$store.getters && this.$store.getters.getCurrentUser;
        const username = user && user.Username ? user.Username : '';
        if (username) {
          const { Storage } = await import('@/services/Storage');
          await Storage.setFloatPending(username, true);
        }
      } catch (e) {}
      return this.$router.push({ name: 'pos' });
    }

    // If online, check if float already assigned on server
    try {
      const assigned = await this.$store.dispatch('getCurrentUserFloat');
      const user = this.$store && this.$store.getters && this.$store.getters.getCurrentUser;
      const username = user && user.Username ? user.Username : '';
      if (assigned) {
        if (username) {
          const { Storage } = await import('@/services/Storage');
          await Storage.clearFloatPending(username);
        }
        return this.$router.push({ name: 'pos' });
      }
    } catch (e) {
      // If check fails, allow form to display
    }
  },
  components: {FloatAssignForm},
  computed: {
    curUser() {
      const user = this.$store && this.$store.getters && this.$store.getters.getCurrentUser;
      return user && user.Username ? user.Username : '';
    },
  },
  methods: {
    greeting() {
      const today = new Date();
      const currentHour = today.getHours()
      const currentMin = today.getMinutes()
      if (currentHour >= 0 && (currentHour <= 11 && currentMin <= 59)) {
        return 'Good Morning'
      } else if (currentHour >= 12 && (currentHour <= 17 && currentMin <= 59)) {
        return 'Good Afternoon'
      } else {
        return 'Good Evening'
      }
    }
  }
}
</script>

<style>
.page {
  background: var(--bg-gradient);
  min-height: 100vh;

}

.header-section {
  width: 100%;
  color: var(--text-primary);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--card-border);
  padding-bottom: 20px !important;
}

.header-section h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.header-section p {
  font-size: 1.2rem;
  opacity: 0.8;
}

.float-form-container {
  width: 90%;
  max-width: 450px;
  margin-top: -80px; /* Adjust to overlap with header slightly */
  background: var(--card-bg);
  border: var(--card-border);
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  padding: 30px;
}

@media (max-width: 768px) {
  .float-form-container {
    margin-top: -60px;
    width: 95%;
    padding: 20px;
  }

  .header-section h1 {
    font-size: 2rem;
  }

  .header-section p {
    font-size: 1rem;
  }
}
</style>
